import { SETTINGS_PATH } from './settings';

const ROOT_PATH = `${SETTINGS_PATH}/regions` as const;

export const ROOT = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
